import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useNavigate, useParams} from "react-router";
import type {DataFileRouteMatch} from "../../routing/catRoutes";
import {useStores} from "../../stores";
import {NotFound} from "../../routing/pages/NotFound";
import {MainComponent} from "../../components/main/MainComponent";
import {LoadingSpinnerPie} from "../../components/loading-pie/LoadingSpinnerPie";
import type {RouteWrapperProps} from "./RouteWrapperProps";
import {toJS} from "mobx";

export const TaxonomyIngestionWrapper: React.FC<RouteWrapperProps> = observer(({children, state}) => {
    const {rootAppStore, taxonomyIngestionStore} = useStores();
    const params = useParams<DataFileRouteMatch>();
    const navigate = useNavigate();
    const isNoData = state.dataType === 'no_data';

    console.log("TaxonomyIngestionWrapper", toJS(state))

    // TODO: See if this can be optimized, probably by the usage of react Context
    // Beware: This can cause the page to be rendered with the previous state, we have to be resilient against this

    useEffect(() => rootAppStore.setApp(state), [])

    // The magic that loads the job
    useEffect(() => {
        if (!isNoData)
            taxonomyIngestionStore.initTaxonomyFile(navigate, params);
    }, [isNoData])

    return <MainComponent state={state}>
        {
            isNoData
                ? (children)
                : (
                    taxonomyIngestionStore.taxonomyFileNotFound
                        ? <NotFound msg={"Could not find taxonomy ingestion data on the server anymore"}/>
                        : taxonomyIngestionStore.taxonomyFile
                            ? children
                            : <div className="loading-spinner">
                                <LoadingSpinnerPie/>
                            </div>
                )
        }
    </MainComponent>;
});
